module.exports = __webpack_public_path__ + "img/sport6_hover.8e0d9089.png";